import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
  Box,
  styled
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import api from '../api';

const StyledPaper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3]
}));

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[4]
  }
}));

const VehicleSelection = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadVehicles = async () => {
      try {
        setLoading(true);
        const res = await api.get('/vehicles');
        setVehicles(res.data || []);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || 'Fahrzeuge konnten nicht geladen werden');
      } finally {
        setLoading(false);
      }
    };
    loadVehicles();
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <StyledPaper elevation={3}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Typography 
            variant="h3" 
            component="h1" 
            sx={{ 
              [theme.breakpoints.down('sm')]: {
                fontSize: '2rem'
              }
            }}
          >
            Fahrzeug-Quiz
          </Typography>
        </Box>

        <Typography 
          variant="h6" 
          align="center" 
          color="text.secondary" 
          sx={{ mb: 4 }}
        >
          Wähle ein Fahrzeug aus, um dein Wissen über die Ausrüstung zu testen
        </Typography>

        {loading && (
          <Typography align="center" sx={{ mb: 2 }}>
            Lade Fahrzeuge...
          </Typography>
        )}
        {error && (
          <Typography align="center" color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Grid container spacing={3}>
          {vehicles.map((vehicle) => (
            <Grid item xs={12} sm={6} key={vehicle.id}>
              <StyledCard>
                <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <Box
                    sx={{
                      height: 200,
                      mb: 2,
                      backgroundImage: `url(${vehicle.image || vehicle.imageUrl || ''})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      borderRadius: theme.spacing(1)
                    }}
                  />
                  <Typography 
                    variant="h5" 
                    component="h2" 
                    gutterBottom
                    sx={{ 
                      [theme.breakpoints.down('sm')]: {
                        fontSize: '1.5rem'
                      }
                    }}
                  >
                    {vehicle.name}
                  </Typography>
                  {vehicle.description && (
                    <Typography 
                      variant="body1" 
                      color="text.secondary"
                      sx={{ mb: 2, flexGrow: 1, whiteSpace: 'pre-line' }}
                    >
                      {vehicle.description}
                    </Typography>
                  )}
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => navigate(`/vehicle/${vehicle.id}/fach-quiz`)}
                      fullWidth
                    >
                      Gerätefach-Quiz
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => navigate(`/vehicle/${vehicle.id}/mc-quiz`)}
                      fullWidth
                    >
                      Multiple-Choice-Quiz
                    </Button>
                  </Stack>
                </CardContent>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </StyledPaper>
    </Container>
  );
};

export default VehicleSelection; 
